import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';

export class UserGroupService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/group`;

    public RouteGetDetail = (id: number) => `${this.baseUrl}/getDetail/${id}`;
    public getDetail(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetDetail(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetDetailByLineId = (id: number) => `${this.baseUrl}/getDetailByLineId/${id}`;
    public getDetailByLineId(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetDetailByLineId(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetPicker = (id: number) => `${this.baseUrl}/getPicker/${id}`;
    public getPicker(id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetPicker(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}